import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import LegalModal from './LegalModal';
import './RegisterForm.css';

const RegisterForm = ({ onBack }) => {
  const [form, setForm] = useState({
    firstName: '', lastName: '', username: '', email: '', password: ''
  });
  const [error, setError] = useState('');
  const [showLegal, setShowLegal] = useState(false);
  const [legalAccepted, setLegalAccepted] = useState(false);
  const { register } = useAuth();
  const { theme } = useTheme();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!legalAccepted) {
      setShowLegal(true);
      return;
    }
    submitRegistration();
  };

  const submitRegistration = async () => {
    try {
      await register(form.firstName, form.lastName, form.username, form.email, form.password);
    } catch (err) {
      setError('Registration failed. Username or email may already exist.');
    }
  };

  const handleLegalAccept = () => {
    setLegalAccepted(true);
    setShowLegal(false);
    submitRegistration();
  };

  return (
    <div className="login-container" style={{ backgroundColor: theme.headerBackground }}>
      {showLegal && <LegalModal onAccept={handleLegalAccept} />}
      <div className="login-box" style={{ backgroundColor: theme.cardBackground }}>
      <img
        src="/logos/3.4_LightAccent_Yellow_blue52_blackWEEKS.png"
        alt="52 in the Lou"
        style={{ height: '60px', objectFit: 'contain', marginBottom: '8px', display: 'block', margin: '0 auto 8px auto' }}
        />
        <p className="login-subtitle">Create Account</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input name="firstName" placeholder="First Name" value={form.firstName}
            onChange={handleChange} className="login-input"
            style={{ backgroundColor: theme.background, color: theme.text, borderColor: theme.border }}
            required />
          <input name="lastName" placeholder="Last Name" value={form.lastName}
            onChange={handleChange} className="login-input"
            style={{ backgroundColor: theme.background, color: theme.text, borderColor: theme.border }}
            required />
          <input name="username" placeholder="Username" value={form.username}
            onChange={handleChange} className="login-input"
            style={{ backgroundColor: theme.background, color: theme.text, borderColor: theme.border }}
            required />
          <input name="email" type="email" placeholder="Email" value={form.email}
            onChange={handleChange} className="login-input"
            style={{ backgroundColor: theme.background, color: theme.text, borderColor: theme.border }}
            required />
          <input name="password" type="password" placeholder="Password" value={form.password}
            onChange={handleChange} className="login-input"
            style={{ backgroundColor: theme.background, color: theme.text, borderColor: theme.border }}
            required />
          <button type="submit" className="login-button"
            style={{ backgroundColor: theme.buttonPrimary, color: theme.buttonText }}>
            Create Account
          </button>
        </form>
        <p className="register-link" style={{ color: theme.subText }}>
          Already have an account?{' '}
          <span onClick={onBack} style={{ color: theme.buttonPrimary }}>Log in</span>
        </p>
        <p
          onClick={() => setShowLegal(true)}
          style={{ color: theme.subText, fontSize: '0.75rem', textAlign: 'center', cursor: 'pointer', marginTop: '8px' }}
        >
          Terms & Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default RegisterForm; 